import { useEffect, useState } from "react";
import { User } from "../../../../../api/accessControl/User";
import { BackendApi } from "../../../../../api/api";
import Shell from "../../../../../components/specific/Shell";
import {DoublePayment} from "./DoublePayment.tsx";
import {DoublePaymentsTable} from "./DoublePaymentsTable.tsx";
import LoadingFrame from "../../../../../components/LoadingFrame.tsx";


function DoublePaymentsPage({ currentUser }: { currentUser: User }) {
    const api = new BackendApi(currentUser.getToken())
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [doublePayments,setDoublePayments] = useState<Array<DoublePayment>>([]);

    async function load(){

        const response = await api.MyBusiness__doublePayments({})
        setDoublePayments(response);
        setIsLoading(false)
    }

    useEffect(() => {
        load();
    },[])

    return (
        <>
            <Shell currentUser={currentUser} isLoading={isLoading} title="Dubbele betalingen">
                <LoadingFrame isLoading={isLoading}>
                    <DoublePaymentsTable data={doublePayments}/>
                </LoadingFrame>
            </Shell>
        </>
    )

}

export default DoublePaymentsPage